// /circles/{id}/edit — bookmark-compat redirect.
//
// Edit moved into the dedicated /admin shell. Anyone with a bookmarked /edit
// URL lands here and is bounced to the admin overview section.

import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authed/circles/$id/edit')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/circles/$id/admin',
      params: { id: params.id },
      search: { section: 'overview' },
    });
  },
});
